import React, { Component } from 'react'
import { IndexLink } from 'react-router'
import { connect } from 'react-redux'
import { toggle } from '../store/siteMenu'
import { TweenMax, Power0 } from 'gsap'
import { selectService } from 'store/selectedService'
import PropTypes from 'prop-types'
import $ from 'jquery'

// Components
import ToggleX from 'components/ToggleX'

// Styles
import './SiteHeader.scss'

// Images
import Logo from 'assets/images/logo.svg'

class SiteHeader extends Component {
  constructor (props) {
    super(props)
    this.toggleSiteMenu = this.toggleSiteMenu.bind(this)
    this.onLogoClick = this.onLogoClick.bind(this)
    // this.state = { visible: false }
    // injectReducer(store, { key: 'visible', siteMenuReducer })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.siteMenuVisible !== this.props.siteMenuVisible && window.innerWidth < 768) {
      let autoAlpha = this.props.siteMenuVisible ? 0 : 1
      TweenMax.to($(this.header).find('.logo, .site-header__bg'), 0.6, { autoAlpha, ease: Power0.easeNone })
    }
  }

  toggleSiteMenu () {
    let visible = !this.props.siteMenuVisible
    this.props.toggle(visible)
  }

  onLogoClick () {
    return false
  }

  render () {
    let toggleClasses = ''
    toggleClasses += (this.props.siteMenuVisible) ? ' toggle-x--close' : ''

    return (
      <header ref={el => { this.header = el }} className='site-header'>
        <div className='site-header__bg' />
        <IndexLink to='/' className='logo' onClick={(event) => {
          if (this.props.siteMenuVisible) {
            this.props.toggle(false)
          }

          if (this.props.selectedService !== null) {
            this.props.selectService(null)
          }
        }}>
          <img src={Logo} alt='Colivar' />
        </IndexLink>
        <ToggleX
          classes={`main-menu-toggle ${toggleClasses}`}
          onInputDown={this.toggleSiteMenu} />
      </header>
    )
  }
}

const mapDispatchToProps = {
  toggle : (visibility) => toggle(visibility),
  selectService: (id) => selectService(id)
}

const mapStateToProps = (state) => ({
  selectedService: state.selectedService,
  siteMenuVisible: state.siteMenuVisible,
  path: state.location.pathname
})

SiteHeader.propTypes = {
  toggle: PropTypes.func,
  siteMenuVisible: PropTypes.bool,
  selectService: PropTypes.func,
  selectedService: PropTypes.number,
  // path: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteHeader)



// WEBPACK FOOTER //
// ./src/containers/SiteHeader.js